<template>
<w-sliding-popup type="setting" ref="slidingPopup" :title="selectTitle" width="600px">
  <div slot="content" v-loading="isLoading" element-loading-text="스크립트 실행 중..">
    <el-steps :active="activeStep" finish-status="success">
      <el-step v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
    </el-steps>
    <w-target-test-device-list ref="targetDeviceList" v-show="activeStep === 1" @changeSize="changeSize" :activeCompanyId="activeCompanyId" :dataList="targetDeviceList"></w-target-test-device-list>
    <w-script-test-result v-show="activeStep === 2" :testResult="testResult"></w-script-test-result>
  </div>
  <el-row v-show="activeStep !== 1" slot="footer" type="flex" justify="space-between">
    <el-button size="large" v-show="activeStep !== 1" @click="prevStep"><i class="fal fa-arrow-left mr-r2" />이전 단계</el-button>
    <el-button size="large" type="solid" v-if="activeStep === 2" @click="close">확인</el-button>
  </el-row>
  <el-row v-show="activeStep === 1" slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" :disabled="!isCheckList" @click="executeTest">테스트 실행</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import forEach from 'lodash/forEach';
import msgUtil from '@/utils/message';
import netdeviceConfigApi from '@/api/config/netdevice/netdevice-info';
import WTargetTestDeviceList from '@/views/settings/netdevice/ScriptSettings/component/TargetTestDeviceList';
import WScriptTestResult from '@/views/settings/netdevice/ScriptSettings/component/ScriptTestResult';

export default {
  name: 'WScriptTestPopup',
  components: {
    WTargetTestDeviceList,
    WScriptTestResult,
  },
  props: {
    editRow: Object,
    popupParams: {
      type: Object,
      default: () => {},
    },
    activeCompanyId: Number,
  },
  data() {
    return {
      scriptTestTask: 'scriptTestTask',
      isLoading: false,
      targetDeviceList: [],
      isCheckList: false,
      testResult: [],
      selectTitle: '',
      activeStep: 1,
      stepTitles: ['대상 장비 선택', '테스트 결과 확인'],
    };
  },
  watch: {
    editRow: {
      handler(row) {
        this.selectTitle = `[${row.templateName}] 스크립트 테스트`;
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.$taskManager.existTask(this.scriptTestTask)) {
      this.$taskManager.removeTask(this.scriptTestTask);
    }
  },
  methods: {
    open() {
      this.activeStep = 1;
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.$refs.targetDeviceList.initTargetInfo();
      });
    },
    /**
     * [executeTest 설정 > 네트워크 설정 > 스트립트 설정>스트립트 테스트를 수행한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    executeTest() {
      const me = this;
      const executeParams = [];
      if (me.activeStep === 1) {
        const deviceList = me.$refs.targetDeviceList.changeDeviceList;
        if (deviceList.length > 0) {
          forEach(deviceList, (item) => {
            executeParams.push(item.objId);
          });
          me.isLoading = true;
          netdeviceConfigApi
            .executeScript({
              objIds: executeParams,
              script: me.editRow.script,
              scriptName: me.editRow.templateName,
            })
            .then((response) => {
              if (response.data.success) {
                const jobSeqData = response.data.data;
                this.$taskManager.createTask(
                  this.scriptTestTask,
                  1,
                  () => {
                    netdeviceConfigApi
                      .checkScriptCompletion({
                        jobSeq: jobSeqData,
                        objCount: deviceList.length,
                      })
                      .then((result) => {
                        if (result.data.data) {
                          me.$taskManager.removeTask(this.scriptTestTask);
                          // ncmtemplatelist 호출
                          me.loadNcmScriptResult(jobSeqData, true);
                        }
                      });
                  },
                  false,
                  60,
                  () => {
                    me.$taskManager.removeTask(this.scriptTestTask);
                    me.loadNcmScriptResult(jobSeqData, false);
                  },
                );
                this.$taskManager.startTask(this.scriptTestTask);
              }
            });
        } else {
          me.isLoading = false;
          this.$message('데이터를 확인해 주십시오.');
        }
      }
    },
    /**
     * [executeTest 설정 > 네트워크 설정 > 스트립트 설정> 스트립트 테스트 결과를 가져온다.]
     * @author yelim
     * @return {[type]} [description]
     */
    loadNcmScriptResult(jobSeqData, success) {
      this.isLoading = false;
      if (success) {
        netdeviceConfigApi
          .getExecuteScriptResult({
            jobSeq: jobSeqData,
          })
          .then((response) => {
            if (response.data.success) {
              this.testResult = response.data.data;
              this.activeStep = this.activeStep + 1;
            }
          });
      } else {
        this.$message(msgUtil.getResultMsgData('완료', '스크립트 수행', false));
      }
    },
    close() {
      this.$refs.slidingPopup.close();
      if (this.$taskManager.existTask(this.scriptTestTask)) {
        this.$taskManager.removeTask(this.scriptTestTask);
      }
    },
    prevStep() {
      this.activeStep = this.activeStep - 1;
    },
    changeSize(size) {
      if (size > 0) {
        this.isCheckList = true;
      } else {
        this.isCheckList = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/ScriptSettings/popup/ScriptTestPopup.vue